import { Routes } from '@angular/router';
import { AppLoginComponent } from './components/app-login/app-login.component';
import { authGuard } from './guards/auth.guard';
import { abilityGuard } from './guards/ability.guard';
import { MENU_SUBJECTS } from './components/common/side-nav/menu-subjects';
import { UNAGRO_DENY_MESSAGE } from './components/unagro/unagro.format';

export const routes: Routes = [
  {
    path: 'login',
    component: AppLoginComponent,
    data: { hideNav: true },
  },
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: 'home', loadComponent: () => import('./components/home/home.component').then((m) => m.HomeComponent)
      },
      {
        path: 'users', canActivate: [abilityGuard], data: { subject: MENU_SUBJECTS.users }, loadComponent: () => import('./components/users/users.component').then((m) => m.UsersComponent)
      },
      {
        path: 'users/new', canActivate: [abilityGuard], data: { subject: MENU_SUBJECTS.users },
        loadComponent: () =>
          import('./components/users/new-user-form/new-user-form.component').then((m) => m.NewUserFormComponent),
      },
      {
        path: 'roles', canActivate: [abilityGuard], data: { subject: MENU_SUBJECTS.roles },
        loadComponent: () => import('./components/roles/roles.component').then((m) => m.RolesComponent),
      },
      {
        path: 'roles/form', canActivate: [abilityGuard], data: { subject: MENU_SUBJECTS.roles },
        loadComponent: () => import('./components/roles/rol-form/rol-form.component').then((m) => m.RolFormComponent),
      },
      {
        path: 'lotes/editar',
        loadComponent: () =>
          import('./components/lotes/edita-lote/edita-lote.component').then((m) => m.EditaLoteComponent),
      },
      {
        path: 'lotes',
        loadComponent: () => import('./components/lotes/lotes.component').then((m) => m.LotesComponent),
      },
      {
        path: 'despacho',
        loadComponent: () => import('./components/despacho/despacho.component').then((m) => m.DespachoComponent),
      },
      {
        path: 'asignaciones/bolsones', canActivate: [abilityGuard], data: { subject: MENU_SUBJECTS.assignments },
        loadComponent: () => import('./components/asignaciones/asig-bolsones/asig-bolsones.component').then((m) => m.AsigBolsonesComponent),
      },
      {
        path: 'asignaciones', canActivate: [abilityGuard], data: { subject: MENU_SUBJECTS.assignments },
        loadComponent: () => import('./components/asignaciones/asignaciones.component').then((m) => m.AsignacionesComponent),
      },
      {
        path: 'trazabilidad/traslado-curado', canActivate: [abilityGuard], data: { subject: MENU_SUBJECTS.curingTransfer },
        loadComponent: () => import('./components/traslado-curado/traslado-curado.component').then((m) => m.TrasladoCuradoComponent),
      },
      {
        path: 'trazabilidad/curado', canActivate: [abilityGuard], data: { subject: MENU_SUBJECTS.curing },
        loadComponent: () => import('./components/curado/curado.component').then((m) => m.CuradoComponent),
      },
      {
        path: 'trazabilidad/salida-campo', canActivate: [abilityGuard], data: { subject: MENU_SUBJECTS.seedBackoffice },
        loadComponent: () => import('./components/salida-campo/salida-campo.component').then((m) => m.SalidaCampoComponent),
      },
      {
        path: 'trazabilidad/fletes', canActivate: [abilityGuard], data: { subject: MENU_SUBJECTS.shipments },
        loadComponent: () => import('./components/fletes/fletes.component').then((m) => m.FletesComponent),
      },
      {
        path: 'unagro',
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'lotes' },
          {
            path: 'lotes', canActivate: [abilityGuard],
            data: { subject: MENU_SUBJECTS.seedUnagro, action: 'view_stock', denyMessage: UNAGRO_DENY_MESSAGE },
            loadComponent: () =>
              import('./components/unagro/unagro-lotes/unagro-lotes.component').then((m) => m.UnagroLotesComponent),
          },
        ],
      },
      {
        path: 'edita-kg', canActivate: [abilityGuard], data: { subject: MENU_SUBJECTS.seedManagement },
        loadComponent: () => import('./components/edita-kg/edita-kg.component').then((m) => m.EditaKgComponent),
      },
      {
        path: 'facturas',
        loadComponent: () => import('./components/facturas/facturas.component').then((m) => m.FacturasComponent),
      },
    ],
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  { path: '**', loadComponent: () => import('./components/common/404/not-found.component').then((m) => m.NotFoundComponent) },
];
